import { render, staticRenderFns } from "./LapLamp7A.vue?vue&type=template&id=638301d1"
import script from "./LapLamp7A.vue?vue&type=script&lang=js"
export * from "./LapLamp7A.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports